import { DeviceEventControl, SiteAllDevices } from '@/api/site';
import { trim } from '@/libs/utils';

export default {
  data() {
    return {
      // 站点编辑搜索
      deviceControlSearch: {
        date: null,
        keyword: '',
        types: [],
      },
      deviceControlSearchDate: null,

      // 站点编辑数据
      deviceControlData: null,

      // 设备控制类型
      deviceControlType: [],

      // 分页
      deviceControlPagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 20,
        // 记录总条数
        total: 0,
      },

      // 站点编辑表头
      deviceControlColumns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          width: 60,
          dataIndex: 'id',
        },
        {
          title: this.$t('device_table_name'),
          dataIndex: 'devName',
          scopedSlots: { customRender: 'devName' },
        },
        {
          title: this.$t('device_control_type'),
          dataIndex: 'operationType',
          scopedSlots: { customRender: 'operationType' },
        },
        {
          title: this.$t('deviceModel_table_params'),
          dataIndex: 'executeData',
          scopedSlots: { customRender: 'executeData' },
        },

        {
          title: this.$t('site_table_user'),
          dataIndex: 'executeUser',
        },

        {
          title: this.$t('logs_table_ip'),
          dataIndex: 'hostIp',
        },

        {
          title: this.$t('logs_table_location'),
          dataIndex: 'location',
          scopedSlots: { customRender: 'Location' },
        },

        {
          title: this.$t('logs_table_execute_start_time'),
          dataIndex: 'executeStartTime',
          scopedSlots: { customRender: 'executeStartTime' },
          sorter: true,
        },

        {
          title: this.$t('logs_table_execute_end_time'),
          dataIndex: 'executeEndTime',
          scopedSlots: { customRender: 'executeEndTime' },
        },

        {
          title: this.$t('logs_table_execute_end_result'),
          dataIndex: 'executeResult',
          scopedSlots: { customRender: 'executeResult' },
        },
      ],
      tableLoading: false,
    };
  },
  created() {
    this.getDeviceControlType();
  },

  methods: {
    // date picker change
    deviceControlDateChange(value) {
      this.deviceControlPagination.current = 1;
      if (value && value.length === 2) {
        const _startDate = value[0].startOf('day').valueOf();
        const _endData = value[1].endOf('day').valueOf();
        this.deviceControlSearch.date = `${_startDate}-${_endData}`;
      } else {
        this.deviceControlSearch.date = undefined;
      }
      this.getDeviceControlData();
    },

    // 获取站点编辑数据
    getDeviceControlData() {
      const params = {
        // 排序字段，0表示默认按主键，1按操作类型， 2按执行人，3按执行时间
        // 默认为执行时间
        orderField: 3,
        // 默认为1，即倒序
        orderType: 1,
        ...this.deviceControlSearch,
        pageSize: this.deviceControlPagination.pageSize,
        pageNo: this.deviceControlPagination.current,
        stationId: this.stationId,
      };

      if (params.types && params.types.length > 0) {
        params.types = params.types.join(',');
      } else {
        delete params.types;
      }

      // 去掉空格
      if (params.keyword) {
        params.keyword = trim(params.keyword);
      }

      this.tableLoading = true;
      DeviceEventControl(params)
        .then(res => {
          if (res.code === 0) {
            this.deviceControlData = res.data;
            this.deviceControlPagination.total = res.totalCount;
          }
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    // reset
    resetDeviceControlSearch() {
      this.deviceControlPagination.current = 1;
      this.deviceControlSearchDate = null;
      this.deviceControlSearch = {
        startDate: null,
        endDate: null,
        name: '',
        types: [],
      };

      this.getDeviceControlData();
    },

    // page change
    deviceControlPageChange(page) {
      this.deviceControlPagination.current = page;
      this.getDeviceControlData();
    },

    // 表格排序
    handleDeviceControlTableChange(pagination, filters, sorter) {
      const { field, order } = sorter;
      // orderField:"排序字段，0表示默认按主键，1按操作类型， 2按执行人，3按执行时间",
      // orderType:"排序类型, 0为升序，1为倒序",
      if (field === 'id') {
        this.deviceControlSearch.orderField = 0;
      } else if (field === 'updateType') {
        this.deviceControlSearch.orderField = 1;
      } else if (field === 'executeUser') {
        this.deviceControlSearch.orderField = 2;
      } else if (field === 'executeStartTime') {
        this.deviceControlSearch.orderField = 3;
      }
      this.deviceControlSearch.orderType = order === 'ascend' ? 0 : 1;

      this.getDeviceControlData();
    },

    // 获取所有设备的控制类型
    getDeviceControlType() {
      SiteAllDevices({
        stationId: this.stationId,
      }).then(res => {
        if (res.code === 0) {
          this.deviceControlType = res.data;
        }
      });
    },
  },
};
